export const groupByProperty = (list: any[], properties: string[]) => list.reduce((groups, item) => {
    //! THAT FUNCTION NEED A REFACTORING TO ACCEPT MULTIPLE PROPERTIES  
    const group = (groups[item[properties[0]][properties[1]]] || []);
    group.push(item);
    groups[item[properties[0]][properties[1]]] = group;
    return groups;
}, {});